const features = [
  {
    feature: "DENIED_POLES_DIPS",
    label: "Denied Poles Dips",
    sde_table: "POLE",
  },
  { feature: "DOWN_GUY", label: "Down Guy", sde_table: "POLE" },
  { feature: "FLOWER_POT", label: "Flower Pot", sde_table: "STRUCTURE" },
  {
    feature: "HANDHOLE_LARGE",
    label: "Handhole (Large)",
    sde_table: "STRUCTURE",
  },
  {
    feature: "HANDHOLE_MEDIUM",
    label: "Handhole (Medium)",
    sde_table: "STRUCTURE",
  },
  {
    feature: "HANDHOLE_SMALL",
    label: "Handhold (Small)",
    sde_table: "STRUCTURE",
  },
  { feature: "POLE_GUARD", label: "Pole Guard", sde_table: "POLE" },
  { feature: "RISER", label: "Riser", sde_table: "POLE" },
  { feature: "SLACK_LOOP", label: "Slack Loop", sde_table: "POLE" },
  { feature: "SPLICE_CASE", label: "Splice Case", sde_table: "SPLICECLOSURE" },

  { feature: "CONCRETE_RESTORATION", label: "Concrete Restoration", sde_table: "GREENFIELD" },
  { feature: "HARDSCAPE_POTHOLING", label: "Hardscape Potholing", sde_table: "GREENFIELD" },
  { feature: "ASPHALT_RESTORATION", label: "Asphalt Restoration", sde_table: "GREENFIELD" },
];

export default features;
